import { RequestBuilder } from '@teqplay/api'
import { User } from '@teqplay/auth'

/**
 * Context available to the RestClient.
 */

export type TRestContext = {
  appName: string
  user?: User
}

/**
 * Shared RequestBuilder with our context type.
 */
export const requestBuilder = new RequestBuilder<TRestContext>()
